(() => {
  function closeMegaMenu(trigger) {
    const navItem = trigger.closest('[data-nav-item]');
    if (!navItem) return;

    navItem.classList.remove('is-visible');
    navItem.setAttribute('aria-expanded', 'false');
    navItem.dispatchEvent(new Event('mouseleave', { bubbles: true }));

    const disclosure = navItem.querySelector('details[open]');
    if (disclosure) disclosure.removeAttribute('open');

    document.body.classList.remove('megamenu-opened');

    const header = trigger.closest('[data-site-header]');
    if (header) header.classList.remove('site-header--menu-opened');
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-megamenu-close]');
    if (!trigger) return;
    event.preventDefault();
    closeMegaMenu(trigger);
  });
})();
